import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBCsyCAGvdMb8dQ3KdGXfsGwgVXVVcWwGc",
  authDomain: "techdave-solutions.firebaseapp.com",
  projectId: "techdave-solutions",
  storageBucket: "techdave-solutions.firebasestorage.app",
  messagingSenderId: "730671773542",
  appId: "1:730671773542:web:d31b547bd16ba51bd57aa7",
  measurementId: "G-LTDT9T07LK"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);